export default __webpack_public_path__ + "static/media/article_img_05.5dbff64b.png";